import React, { Component, Fragment } from "react";
import { withTranslation, Trans } from "react-i18next";
import config from "../../../config";
import i18n from "../../../i18n";
import {
  GelContentContainer,
  AlphabetJumpList,
  Notice,
} from "cw-styleguide-react";
import Tabs from "../../../components/Tabs";
import AutocompleteSearch from "../../../components/AutocompleteSearch";
import Helmet from 'react-helmet';

class GlossaryLandingView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t("route_app_title")}</title>
        </Helmet>
        <AutocompleteSearch jobs={this.props.jobs} />
        <GelContentContainer>
          <Tabs />

          <AlphabetJumpList glossary={this.props.glossary} />
          <div
            role="region"
            className="anchor-list__content"
            aria-live="polite"
          >
            {this.props.glossary.map((term) => {
              if (term.jobs.length) {
                return (
                  <Fragment key={term.letter}>
                    <div className="anchor-list__anchor">
                      <div
                        className="anchor__hook"
                        id={term.letter}
                        tabIndex={-1}
                      />
                      {term.letter}
                    </div>
                    <ul className="anchor-list__list style--columns-3">
                      {term.jobs.map((job, index) => {
                        return (
                          <li key={index}>
                            <a
                              className={"anchor-list__link"}
                              href={
                                config.basePath[i18n.language] + "/" + job.slug
                              }
                              title={`${this.props.t("styleguide:link_to")} ${
                                job.name
                              }`}
                            >
                              {job.name}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </Fragment>
                );
              }
              return null;
            })}
          </div>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation("local")(GlossaryLandingView);
